import { type Href } from 'expo-router';

import { theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const APPLY_REWARD_FADE_IN_DURATION = theme.transitions.base;
export const APPLY_REWARD_LAYOUT_DURATION = theme.transitions.base;
export const APPLY_REWARD_ENTRANCE_DURATION = theme.transitions.base;

export const CLAIMED_REWARD_DESTINATION: Href = {
  pathname: '/loyalty',
  params: { scrollTo: 'rewards' },
};
